module.exports = __webpack_public_path__ + "img/Sewing.0632b9d1.png";